import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import { CPDPoints } from "components/CPDPoints";
import renderSponsors from "components/Dashboard/renderSponsors";
import renderPartners from "components/Dashboard/renderPartners";
import renderExperts from "components/Dashboard/renderExperts";
import renderSponsorCheckbox from "components/Dashboard/renderSponsorCheckbox";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";
import Checkbox from "material-ui/Checkbox";
import axios from "axios";
import { toast } from "react-toastify";
import { transformWebinarCustomText } from "utils/webinar-custom-text";
import constants from "constants";

const { REF_TYPES } = constants;

class UpcomingWebinarItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      isSubmitting: false,
      is_subscription_sponsor: this.props.webinar.is_subscription_sponsor,
    };
  }

  componentDidUpdate() {
    if (this.props.scrollTo == this.props.webinar.id) {
      const el = document.getElementById(`upcoming${this.props.scrollTo}`);
      el.scrollIntoView();
    }
  }

  handleChangeQuestion = (e) => {
    const { value } = e.target;
    this.setState((prev) => ({ ...prev, question: value }));
  };

  onSubmitQuestion = async () => {
    this.setState((prev) => ({ ...prev, isSubmitting: true }));
    try {
      const res = await axios.post("/api/v1/user_questions", {
        user_questions: {
          webinar_id: this.props.webinar.id,
          body: this.state.question,
        },
      });
      if (res.status === 200)
        toast.success(
          "Thank you for submitting your questions which have been received. While the speaker(s) make every effort to answer all questions, a response is not guaranteed due to time constraints. We will forward answers to any question that is not covered live should the speaker(s) decide to answer it post-webinar.",
        );
    } catch (err) {
      toast.warn("Something is wrong!");
      console.log(err);
    }
    this.setState((prev) => ({ ...prev, isSubmitting: false, question: "" }));
  };

  render() {
    const {
      webinar,
      subscriptions,
      userRole,
      user,
      toggleSubscription,
      onSubscriptionChange,
      toggleSponsorsSubscription,
      landing,
      noTitle,
      openAddToCalendarModal,
    } = this.props;
    const isIndustryWebinar =
      Array.isArray(webinar.user_types) &&
      webinar.user_types.length === 1 &&
      webinar.user_types[0] === 11;
    const canRegister =
      userRole !== "sponsor" ||
      (user.sponsor_type === "pharmaceutical" && isIndustryWebinar);

    const {
      webinar_title,
      start_date,
      end_date,
      sponsor,
      sponsors,
      partnerships,
      subscription_id,
      experts,
      sessions,
      id,
    } = webinar;

    const { handleChangeQuestion, onSubmitQuestion } = this;

    const { subscriptionEvents, is_subscription_sponsor, question } =
      this.state;
    const subscriptionLabel =
      subscriptionEvents &&
      subscriptionEvents[webinar.id] &&
      subscriptionEvents[webinar.id].length
        ? "Confirm selection"
        : "Click here to select breakout rooms";

    const isCertificateOfParticipation =
      webinar.ref_type === "certificate_of_participation";

    const isCustomCertificate = isCertificateOfParticipation;

    if (noTitle)
      return (
        <div className="section_previous noTitle">
          <div className="content">
            <div>
              <p className="section_topic">{webinar_title}</p>
              {webinar.vimeo_url && webinar.duration ? (
                <div>
                  <p className="current_card_date">Duration</p>
                  <p className="current_card_time">
                    {webinar.duration || "N/A"}
                  </p>
                </div>
              ) : (
                <div>
                  <p className="current_card_date">
                    <span>
                      {start_date !== undefined &&
                        moment(start_date).format("MMM DD").toUpperCase()}{" "}
                    </span>
                    {start_date !== undefined &&
                      moment(start_date).format("YYYY")}
                  </p>
                  <p className="current_card_time">
                    {start_date !== undefined &&
                      moment(start_date).format("h:mm a").toUpperCase()}
                    {" - "}
                    {end_date !== undefined &&
                      moment(end_date).format("h:mm a").toUpperCase()}
                  </p>
                </div>
              )}
            </div>
            <div>
              {sponsors && sponsors.length && sponsors.length > 0 ? (
                <div>
                  <p>Brought to you by:</p>
                  {renderSponsors(sponsor, sponsors, noTitle)}
                </div>
              ) : null}
              {partnerships &&
              partnerships.length &&
              partnerships.length > 0 ? (
                <div>
                  <p>In partnership with:</p>
                  {renderPartners(partnerships, noTitle)}
                </div>
              ) : null}
            </div>
          </div>
          <div className="experts">{renderExperts(experts, noTitle)}</div>
        </div>
      );

    if (this.props.isMobile) {
      return (
        <div className="section_previous" id={`upcoming${id}`}>
          <p className="section_topic">{webinar_title}</p>
          <div className="section_info_mobile ">
            <div className="section_topic_mobile">
              {webinar.vimeo_url && webinar.duration ? (
                <div>
                  <p className="current_card_date">Duration</p>
                  <p className="current_card_time">{webinar.duration}</p>
                </div>
              ) : (
                <div>
                  <p className="current_card_date">
                    <span>
                      {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                    </span>
                    {moment(start_date).format("YYYY")}
                  </p>
                  <p className="current_card_time">
                    {moment(start_date).format("h:mm a").toUpperCase()}
                    {" - "}
                    {moment(end_date).format("h:mm a").toUpperCase()}
                  </p>
                </div>
              )}
              {webinar && webinar.document_url ? (
                <div className="col l1">
                  <div className="current_points">
                    Agenda:{" "}
                    <a
                      className="download_attachment"
                      target="_blank"
                      href={webinar.document_url}
                    >
                      Download
                    </a>
                  </div>
                </div>
              ) : null}
              {webinar && webinar.ppt_document_url ? (
                <div className="col l1">
                  <div className="current_points">
                    Resources:{" "}
                    <a
                      className="download_attachment"
                      target="_blank"
                      href={webinar.ppt_document_url}
                    >
                      Download
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
            {renderExperts(experts)}
            <div className="section_sponsors_mobile">
              <div>
                {sponsors && sponsors.length && sponsors.length > 0 ? (
                  <div>
                    <p>Brought to you by:</p>
                    {renderSponsors(sponsor, sponsors, false)}
                  </div>
                ) : null}
              </div>
              <div className="section_sponsors_join">
                {webinar && webinar.cpd_points && !isCustomCertificate ? (
                  <div className="col l1">
                    <div className="current_points">
                      <CPDPoints webinar={webinar} />
                    </div>
                  </div>
                ) : null}

                {isCertificateOfParticipation && (
                  <div className="col l1">
                    <div
                      className="current_points"
                      style={{ textAlign: "center" }}
                    >
                      <p>Certificate of Participation</p>
                    </div>
                  </div>
                )}

                <div className="current_join">
                  {canRegister && (
                    <button
                      className={`${
                        subscription_id ? "" : "register-interest"
                      } ${!subscription_id ? "webinar-events-show" : ""}`}
                      onClick={() => {
                        toggleSubscription();
                      }}
                    >
                      {!!(sessions && sessions.length) &&
                        (subscription_id
                          ? "Breakout room selected"
                          : subscriptions &&
                              subscriptions[webinar && webinar.id] &&
                              subscriptions[webinar && webinar.id].length
                            ? "Click HERE to confirm selection"
                            : "Click here to select BREAKOUT ROOMS")}
                      {!(sessions && sessions.length) &&
                        (subscription_id ? "REGISTERED" : "REGISTER")}
                    </button>
                  )}

                  {webinar.subscription_sponsor ? (
                    <div className="email_notification_sponsor">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={is_subscription_sponsor}
                            name="subscription_sponsor"
                            onChange={() => {
                              this.setState({
                                ...this.state,
                                is_subscription_sponsor:
                                  !this.state.is_subscription_sponsor,
                              });
                              axios.put(
                                "/api/v1/subscription_sponsors/" + webinar.id,
                              );
                            }}
                          />
                        }
                        label={
                          <span className="email_notification_label">
                            <div className="checkbox-sponsor">
                              {webinar.sponsor_newsleter_title ||
                                "Check the box if you would like to learn more about"}
                              {/* <div className="sponsor_name_check">
                                {sponsor && sponsor.title && (
                                  <p>{sponsor.title}</p>
                                )}
                              </div> */}
                              {/* {sponsors &&
                              sponsors.length &&
                              sponsors.length > 0 ? (
                                <div>
                                  {renderSponsorCheckbox(sponsor, sponsors)}
                                </div>
                              ) : null} */}
                            </div>
                          </span>
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            {partnerships && partnerships.length && partnerships.length > 0 ? (
              <div className="partnership-title-mobile">
                <p>In partnership with:</p>
                {renderPartners(partnerships)}
              </div>
            ) : null}
          </div>

          {!landing && userRole && webinar.show_user_questions && (
            <div className="question">
              <input
                type="text"
                value={question}
                onChange={handleChangeQuestion}
                placeholder="To ask a question in advance, please submit it here. Please note that the panel may not have time to answer all questions."
              />
              <button
                disabled={this.state.isSubmitting}
                onClick={onSubmitQuestion}
              >
                Send
              </button>
            </div>
          )}
          {Boolean(webinar.custom_text_1 || webinar.custom_text_2) && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px",
                gap: "40px",
              }}
            >
              <div
                style={{ width: "45%", textAlign: "left" }}
                dangerouslySetInnerHTML={{
                  __html: webinar.custom_text_1
                    ? transformWebinarCustomText(webinar.custom_text_1)
                    : "",
                }}
              />
              <div
                style={{ width: "45%", textAlign: "right" }}
                dangerouslySetInnerHTML={{
                  __html: webinar.custom_text_2
                    ? transformWebinarCustomText(webinar.custom_text_2)
                    : "",
                }}
              />
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="section_previous" id={`upcoming${id}`}>
        <p className="section_topic">{webinar_title}</p>
        <div className="section_info row">
          <div className="col l3 webinar_title">
            <p className="section_previous_theme"></p>
            {partnerships && partnerships.length && partnerships.length > 0 ? (
              <div>
                <p>In partnership with:</p>
                {renderPartners(partnerships)}
              </div>
            ) : null}
          </div>
          {webinar && webinar.document_url ? (
            <div className="col l1">
              <div className="current_points">
                Agenda:
                <a
                  className="download_attachment"
                  target="_blank"
                  href={webinar.document_url}
                >
                  Download
                </a>
              </div>
            </div>
          ) : null}
          {webinar && webinar.ppt_document_url ? (
            <div className="col l1">
              <div className="current_points">
                Resources:
                <a
                  className="download_attachment"
                  target="_blank"
                  href={webinar.ppt_document_url}
                >
                  Download
                </a>
              </div>
            </div>
          ) : null}
          {/* {Boolean(webinar.sponsor_representative.length) && (
            <div className="col l2">
              <WebinarSponsorsRepresentative
                sponsors={webinar.sponsor_representative}
              />
            </div>
          )} */}
          <div className="col l2 section_topic">
            <p className="current_card_date">
              <span>{moment(start_date).format("dddd").toUpperCase()} </span>
              <span>
                {moment(start_date).format("D/M/YYYY").toUpperCase()}{" "}
              </span>
              {/*{moment(start_date).format('YYYY')}*/}
            </p>
            <p className="current_card_time">
              {moment(start_date).format("h:mm a").toUpperCase()}
              {" - "}
              {moment(end_date).format("h:mm a").toUpperCase()}
            </p>
          </div>
          <div className="col l2">
            {sponsors && sponsors.length && sponsors.length > 0 ? (
              <div>
                <p>Brought to you by:</p>
                {renderSponsors(sponsor, sponsors, false)}
              </div>
            ) : null}
          </div>
          {webinar && webinar.cpd_points && !isCustomCertificate ? (
            <div className="col l1">
              <div className="current_points">
                <CPDPoints webinar={webinar} />
              </div>
            </div>
          ) : null}

          {isCertificateOfParticipation && (
            <div className="col l1">
              <div className="current_points" style={{ textAlign: "center" }}>
                <p>Certificate of Participation</p>
              </div>
            </div>
          )}

          <div className="col l2">
            <div className="current_join">
              {canRegister && (
                <button
                  className={`${subscription_id ? "" : "register-interest"} ${
                    !subscription_id ? "webinar-events-show" : ""
                  }`}
                  onClick={() => {
                    toggleSubscription();
                  }}
                >
                  {!!(sessions && sessions.length) &&
                    (subscription_id
                      ? "Breakout room selected"
                      : subscriptions &&
                          subscriptions[webinar && webinar.id] &&
                          subscriptions[webinar && webinar.id].length
                        ? "Click HERE to confirm selection"
                        : "Click here to select BREAKOUT ROOMS")}
                  {!(sessions && sessions.length) &&
                    (subscription_id ? "REGISTERED" : "REGISTER")}
                </button>
              )}

              <div style={{ marginTop: "10px" }}>
                <div
                  onClick={openAddToCalendarModal}
                  style={{
                    position: "inherit",
                    color: "#039be5",
                    cursor: "pointer",
                  }}
                >
                  Add To Calendar
                </div>
              </div>

              {webinar.subscription_sponsor ? (
                <div className="email_notification_sponsor">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={is_subscription_sponsor}
                        name="subscription_sponsor"
                        onChange={() => {
                          this.setState({
                            ...this.state,
                            is_subscription_sponsor:
                              !this.state.is_subscription_sponsor,
                          });
                          axios.put(
                            "/api/v1/subscription_sponsors/" + webinar.id,
                          );
                        }}
                      />
                    }
                    label={
                      <span className="email_notification_label">
                        <div className="checkbox-sponsor">
                          {webinar.sponsor_newsleter_title ||
                            "Check the box if you would like to learn more about"}
                          {/* <div className="sponsor_name_check">
                            {sponsor && sponsor.title && <p>{sponsor.title}</p>}
                          </div> */}
                          {/* {sponsors &&
                          sponsors.length &&
                          sponsors.length > 0 ? (
                            <div>
                              {renderSponsorCheckbox(sponsor, sponsors)}
                            </div>
                          ) : null} */}
                        </div>
                      </span>
                    }
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {renderExperts(experts)}
        {!landing && userRole && webinar.show_user_questions && (
          <div className="question">
            <input
              type="text"
              value={question}
              onChange={handleChangeQuestion}
              placeholder="To ask a question in advance, please submit it here. Please note that the panel may not have time to answer all questions."
            />
            <button
              disabled={this.state.isSubmitting}
              onClick={onSubmitQuestion}
            >
              Send
            </button>
          </div>
        )}
        {Boolean(webinar.custom_text_1 || webinar.custom_text_2) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              gap: "40px",
            }}
          >
            <div
              style={{ width: "45%", textAlign: "left" }}
              dangerouslySetInnerHTML={{
                __html: webinar.custom_text_1
                  ? transformWebinarCustomText(webinar.custom_text_1)
                  : "",
              }}
            />
            <div
              style={{ width: "45%", textAlign: "right" }}
              dangerouslySetInnerHTML={{
                __html: webinar.custom_text_2
                  ? transformWebinarCustomText(webinar.custom_text_2)
                  : "",
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

UpcomingWebinarItem.propTypes = {
  // webinar: PropTypes.obj,
  toggleSubscription: PropTypes.func,
  userRole: PropTypes.string,
};

export default UpcomingWebinarItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/UpcomingWebinars/UpcomingWebinarItem.js